<template>
  <div class="block block-cust">
    <img :src="bg" class="img-responsive img-bg" alt="" />
    <div class="main-position">
      <div class="container">
        <div class="main">
          <div class="wrap-title animated" v-animate="'slideInLeft'">
            <div class="title title-cust">合同管理应用场景</div>
            <div class="title2">签署更高效，风险更可控</div>
          </div>
          <div class="animated" v-animate="'slideInRight'">
            <img class="img-icon" :src="p1" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import bg from "@/assets/images/scene/bg.png";
import p1 from "@/assets/images/scene/p1.png";

export default {
  data() {
    return {
      bg,
      p1,
    };
  },
};
</script>

<style scoped>
.block-cust {
  position: relative;
  padding: 0;
}
.main-position {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;
  display: flex;
  align-items: center;
}
.main {
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.title-cust {
  color: #f6c946;
}
.title2 {
  font-size: 24px;
}
.img-bg {
  min-height: 300px;
}
.img-icon {
  width: 250px;
}

/*  */
.mb .wrap-title {
  margin-right: 20px;
}
.mb .title-cust {
  text-align: left;
}
.mb .title2 {
  font-size: 12px;
  margin-top: 10px;
  text-align: left;
}
.mb .img-icon {
  width: 100px;
}
</style>